module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.cart_items_loaded && _vm.cart_items) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: (_vm.canEditOrder() && 'shadow'),
      expression: "canEditOrder() && 'shadow'"
    }],
    staticClass: "cb-breadcrumb",
    class: [{
      'cb-breadcrumb--left': _vm.canEditOrder() && _vm.navIcon == 'left',
      'cb-breadcrumb--right': _vm.canEditOrder() && _vm.navIcon == 'right'
    }],
    attrs: {
      "role": _vm.canEditOrder() && 'navigation',
      "data-cb-id": "cart_summary"
    },
    on: {
      "click": function($event) {
        _vm.canEditOrder() && _vm.navigate()
      }
    }
  }, [_c('div', {
    staticClass: "cb-breadcrumb__wrap"
  }, _vm._l((_vm.consolidated_items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cb-line-item"
    }, [(item.type != 'discount') ? _c('div', {
      staticClass: "cb-line-item__total"
    }, [_c('span', {
      staticClass: "bounce"
    }, [_vm._v("\n              " + _vm._s(_vm._f("cbCurrency")(_vm.amount_due, _vm.currency_code)) + "\n              ")])]) : _vm._e(), _vm._v(" "), (item.type != 'tax') ? _c('div', {
      staticClass: "cb-line-item__name",
      class: {
        'cb-line-item__name--muted': index > 0
      }
    }, [(item.type != 'discount' && item.type != 'tax') ? _c('span', [_vm._v("\n              " + _vm._s(item.title(_vm.st, _vm.t)) + " "), (item.quantity > 1) ? _c('span', [_vm._v(" × " + _vm._s(item.quantity))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 'discount') ? _c('span', [_vm._v("\n              " + _vm._s(_vm._f("cbCurrency")(item.amount, _vm.currency_code)) + " " + _vm._s(_vm.getDiscountTxt()) + "\n              ")]) : _vm._e(), _vm._v(" "), (index == 0 && _vm.consolidated_tax && (_vm.is_tax_inclusive || _vm.is_tax_exclusive)) ? _c('span', {
      staticClass: "cb-line-item__name--muted"
    }, [_vm._v("\n                (" + _vm._s(_vm.cmt('incl_tax.txt')) + ")\n              ")]) : _vm._e()]) : _vm._e()])
  })), _vm._v(" "), (_vm.trialInformation) ? _c('div', {
    staticClass: "cb-breadcrumb__footer",
    style: (_vm.themeColor)
  }, [_vm._v("\n        " + _vm._s(_vm.trialInformation) + "\n      ")]) : _vm._e()]) : _c('div', {
    staticClass: "cb-breadcrumb"
  }, [_c('div', {
    staticClass: "cb-placeholder__container cb-placeholder__tight"
  }, [_c('cb-placeholder', {
    staticClass: "cb-placeholder__left",
    attrs: {
      "custom-class": 'sm rect-xl'
    }
  }), _vm._v(" "), _c('cb-placeholder', {
    staticClass: "cb-placeholder__right",
    attrs: {
      "custom-class": 'sm rect-sm'
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f63701"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/CartItemsComponent.vue
// module id = 341
// module chunks = 41 42 66